var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhyUsIco6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6593 22.012C25.0505 22.1862 25.4664 22.2748 25.8954 22.2748C26.7075 22.2748 27.4718 21.9583 28.0474 21.3835L29.0323 20.3986C29.5004 19.9304 29.7581 19.3084 29.7581 18.6458C29.7581 17.9831 29.5004 17.3611 29.0323 16.8937L27.8812 15.7425C26.9441 14.807 25.314 14.807 24.377 15.7425L23.9132 16.2063C23.7441 16.3754 23.5191 16.4683 23.2795 16.4683H23.1721C22.9326 16.4683 22.7076 16.3754 22.5385 16.2056L22.0377 15.7055C21.8679 15.5349 21.7742 15.3099 21.7742 15.0704C21.7742 14.7968 21.8969 14.5413 22.111 14.3708L22.5276 14.0376C22.9711 13.682 23.2258 13.1521 23.2258 12.5838C23.2258 12.0939 23.0277 11.6141 22.6808 11.2679L21.3489 9.93608C20.4119 9.00051 18.7817 8.99979 17.8447 9.93608L16.8605 10.921C16.285 11.4951 15.9678 12.2601 15.9678 13.0897C15.9678 13.5034 16.0505 13.907 16.2138 14.2887C17.5696 17.4518 20.0483 19.9638 23.1924 21.361L24.6593 22.012ZM17.5486 13.7168C17.4629 13.5172 17.4194 13.306 17.4194 13.073C17.4194 12.6477 17.5856 12.2485 17.8861 11.948L18.871 10.9631C19.0655 10.7686 19.3225 10.6619 19.5968 10.6619C19.8712 10.6619 20.1281 10.7686 20.3226 10.9624L21.6545 12.2942C21.7299 12.3704 21.7742 12.4764 21.7742 12.5838C21.7742 12.7087 21.7183 12.8255 21.6204 12.9039L21.2045 13.237C20.6434 13.6849 20.3226 14.3526 20.3226 15.0704C20.3226 15.6975 20.5665 16.2869 21.01 16.7311L21.5108 17.2312C21.9549 17.6754 22.545 17.9199 23.1721 17.9199H23.2795C23.9066 17.9199 24.4967 17.6754 24.9395 17.2326L25.4033 16.7695C25.7916 16.3812 26.4666 16.3812 26.8549 16.7695L28.006 17.9199C28.2005 18.1137 28.3065 18.3714 28.3065 18.6458C28.3065 18.9201 28.2005 19.1778 28.006 19.3716L27.0218 20.3565C26.5609 20.8166 25.8424 20.9502 25.2494 20.6853L23.7825 20.0335C20.9729 18.7858 18.7592 16.5424 17.5486 13.7168Z",
    fill: "url(#paint0_linear_2332_175)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3872 15.7426C33.3872 9.73942 28.5033 4.85547 22.5001 4.85547C16.497 4.85547 11.613 9.73942 11.613 15.7426C11.613 21.7457 16.497 26.6297 22.5001 26.6297C28.5033 26.6297 33.3872 21.7457 33.3872 15.7426ZM13.0646 15.7426C13.0646 10.54 17.2976 6.30708 22.5001 6.30708C27.7027 6.30708 31.9356 10.54 31.9356 15.7426C31.9356 20.9451 27.7027 25.178 22.5001 25.178C17.2976 25.178 13.0646 20.9451 13.0646 15.7426Z",
    fill: "url(#paint1_linear_2332_175)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.371 28.0814H32.1961L34.4504 25.2333C36.5734 22.5529 37.7419 19.1932 37.7419 15.7427C37.7419 7.33783 30.9041 0.500732 22.5 0.500732C14.0959 0.500732 7.25806 7.33783 7.25806 15.7427V15.7732C7.25806 19.1932 8.42661 22.5529 10.5496 25.234L12.804 28.0814H3.62903C1.62798 28.0814 0 29.7094 0 31.7104V41.8717C0 43.8727 1.62798 45.5007 3.62903 45.5007H41.371C43.372 45.5007 45 43.8727 45 41.8717V31.7104C45 29.7094 43.372 28.0814 41.371 28.0814ZM43.5484 31.7104V33.8878H37.7419V29.533H41.371C42.5715 29.533 43.5484 30.5099 43.5484 31.7104ZM39.1935 44.0491H36.2903V38.2427H24.128C24.1657 38.2013 24.2107 38.1686 24.2456 38.1236L26.4498 35.3394H33.3871V29.533H36.2903V35.3394H43.5484V38.2427H39.1935V44.0491ZM5.80645 29.533H8.70968V35.3394H18.5494L20.7537 38.1244C20.7885 38.1686 20.8335 38.2013 20.8713 38.2427H13.0645V44.0491H10.1613V38.2427H1.45161V35.3394H5.80645V29.533ZM14.5161 39.6943H19.5968V44.0491H14.5161V39.6943ZM21.0484 38.4205C21.4498 38.7682 21.9571 38.9685 22.5 38.9685C23.0429 38.9685 23.5502 38.7682 23.9516 38.4205V44.0491H21.0484V38.4205ZM34.8387 44.0491H25.4032V39.6943H34.8387V44.0491ZM31.9355 29.533V33.8878H27.5995L31.0471 29.533H31.9355ZM8.70968 15.7732V15.7427C8.70968 8.13839 14.8957 1.95235 22.5 1.95235C30.1043 1.95235 36.2903 8.13839 36.2903 15.7732C36.2903 18.868 35.2328 21.9077 33.3116 24.3326L23.1068 37.2229C22.8106 37.5974 22.1879 37.5967 21.8918 37.2229L11.6869 24.3326C9.76718 21.9069 8.70968 18.8673 8.70968 15.7732ZM17.4005 33.8878H10.1613V29.533H13.9529L17.4005 33.8878ZM3.62903 29.533H4.35484V33.8878H1.45161V31.7104C1.45161 30.5099 2.42855 29.533 3.62903 29.533ZM1.45161 41.8717V39.6943H8.70968V44.0491H3.62903C2.42855 44.0491 1.45161 43.0722 1.45161 41.8717ZM41.371 44.0491H40.6452V39.6943H43.5484V41.8717C43.5484 43.0722 42.5715 44.0491 41.371 44.0491Z",
    fill: "url(#paint2_linear_2332_175)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5483 15.0171H42.0967V16.4687H43.5483V15.0171Z",
    fill: "url(#paint3_linear_2332_175)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6452 15.0171H39.1936V16.4687H40.6452V15.0171Z",
    fill: "url(#paint4_linear_2332_175)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80635 15.0171H4.35474V16.4687H5.80635V15.0171Z",
    fill: "url(#paint5_linear_2332_175)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90303 15.0171H1.45142V16.4687H2.90303V15.0171Z",
    fill: "url(#paint6_linear_2332_175)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2332_175",
    x1: 22.8624,
    y1: 9.23413,
    x2: 22.8624,
    y2: 22.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4167B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2332_175",
    x1: 22.4993,
    y1: 4.85547,
    x2: 22.4993,
    y2: 26.6283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4167B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2332_175",
    x1: 22.4983,
    y1: 0.500732,
    x2: 22.4983,
    y2: 45.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4167B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2332_175",
    x1: 42.8224,
    y1: 15.0171,
    x2: 42.8224,
    y2: 16.4686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4167B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2332_175",
    x1: 39.9194,
    y1: 15.0171,
    x2: 39.9194,
    y2: 16.4686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4167B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2332_175",
    x1: 5.08049,
    y1: 15.0171,
    x2: 5.08049,
    y2: 16.4686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4167B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2332_175",
    x1: 2.17717,
    y1: 15.0171,
    x2: 2.17717,
    y2: 16.4686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4167B0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyUsIco6);
export default __webpack_public_path__ + "static/media/why-us-ico-6.fea53438ea8c2737b0bca230427a9936.svg";
export { ForwardRef as ReactComponent };